import isScrollable from "../helper/checkScrollable";

const accordionTabs = () => {

	var tabs = jQuery('.c-tab').find('.c-tab__nav');
  const mq = window.matchMedia('(min-width: 1024px)')

  if (mq.matches === true) {

		tabs.find('a').on('click', function(event) {

			event.preventDefault();

			let target = jQuery(this).attr('href'),
				tabs = jQuery(this).parents('.c-tab__nav'),
				buttons = tabs.find('a').parents('.c-tab__label'),
				item = tabs.parents('.c-tab').find('.c-tab__content');

			buttons.removeClass('--active');
			item.removeClass('--active');

      jQuery(this).parents('.c-tab__label').addClass('--active');
      jQuery(target).addClass('--active');

		});

	} else {
		jQuery('.c-tab__content__label').on('click', function(event) {

      event.preventDefault();

			var container = jQuery(this).parents('.c-tab'),
        content = jQuery(this).parent(),
				currId = content.attr('id');

      container.find('.--active').removeClass('--active');

      content.addClass('--active');

      setTimeout(function () {
        jQuery('html, body').animate({
          scrollTop: content.offset().top - 100
        });
      },50);
		});
	}

};

export default accordionTabs;
